/**
 * Allowed Hurra consent banner language codes.
 * These are the only values that can be returned, ensuring safe interpolation in scripts.
 */
export type HurraLanguage = 'de' | 'en';

/**
 * Maps application locales to Hurra consent banner language codes.
 * Currently the corporate site only supports German (de-DE, de-AT) and English (en).
 *
 * @param locale - The application locale (e.g., 'de-DE', 'de-AT', 'en')
 * @returns The Hurra language code ('de' or 'en') - guaranteed safe for script interpolation
 */
export function getHurraLanguage(locale: string): HurraLanguage {
    // German locales: de-DE, de-AT
    if (locale.startsWith('de')) {
        return 'de';
    }

    // Default to English for 'en' and any other locale
    return 'en';
}

